import React from 'react'
import TitleWithBackNavigation from '../../../../components/TitleWithBackNavigation'
import { Col, Collapse, Row } from 'antd'
import { colorClasses, FaqsData } from '../../../../config/utils/constants';


const Faqs = () => {
    return (
        <div className='w-full'>
            <TitleWithBackNavigation title={"Faq's"} link={'/settings'} />
            <Row className='w-full my-4' justify={'space-between'} gutter={[16, 32]}>
                {
                    FaqsData?.map((faq, index) => {
                        const textColorClass = colorClasses[faq.color] || 'text-black';
                        return (
                            <Col lg={12} md={12} sm={12} xs={24} className='faqs-collapse' key={index}>
                                <Collapse
                                    items={[
                                        {
                                            key: faq.key,
                                            label: <div className={`${textColorClass} flex items-center gap-4`}>
                                                <span className='p-2 rounded-full bg-[#f3f6f8]'>{faq.icon}</span>
                                                <span>{faq.title}</span>
                                            </div>,
                                            children: <p>{faq.content}</p>,
                                        },
                                    ]}
                                    expandIconPosition='end'
                                />
                            </Col>
                        )
                    })
                }

            </Row>
        </div>
    )
}

export default Faqs